/**
 * ewc-bundle — ofertas por quantidade na página de produto, independente de tema.
 *
 * O widget nasce escondido no fim do body e o JS o leva para logo acima do botão de
 * compra, achando sozinho o formulário de /cart/add que o cliente de fato envia
 * (não o da gaveta, não o do upsell). A partir daí ele intercepta o envio e monta o
 * pedido: as unidades da barra escolhida (cada uma com a variante escolhida), os
 * upsells marcados e os brindes liberados — tudo pelo /cart/add.js.
 *
 * O desconto NÃO é aplicado aqui: o widget mostra a conta que o checkout vai
 * cobrar (a mesma do ofertas.py). Quem cobra é o desconto automático da loja.
 *
 * Falha aberto: qualquer erro deixa a página e o botão do tema como estavam.
 */
(function () {
  'use strict';
  if (window.EwcBundle) return;

  var SEL_PICKER = 'variant-selects,variant-radios,variant-picker,.product-variant-picker,.product-form__variants,[data-product-option],.product-form__input--dropdown,.product-form__input--pill,.product-form__input--swatch';
  var SEL_FORA = 'cart-drawer,.cart-drawer,#shopify-section-cart-drawer,#ewc-cart-root,[data-is-cart-upsell],.upsell,.upsells-container,.drawer,.cart-drawer-upsells-container,.ewc-cart';

  function el(tag, classe, texto) { var n = document.createElement(tag); if (classe) n.className = classe; if (texto != null) n.textContent = texto; return n; }
  function dinheiro(cent, fmt) {
    var v = (cent / 100).toFixed(2), p = v.split('.'), i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/g, i + '.' + p[1]).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, i)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, i.replace(/,/g, '.') + ',' + p[1]).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, i.replace(/,/g, '.')).replace(/<[^>]*>/g, '');
  }
  function enxuto(t) { return String(t).replace(/(\d)\.00(?!\d)/g, '$1'); }

  /* ------------------------------------------------------ formulário de compra */
  function achar(root, seletorManual) {
    if (seletorManual) { var m = document.querySelector(seletorManual); if (m) return m; }
    function temBotao(f) { return !!f.querySelector('button[name="add"],[type="submit"]'); }
    function deFora(f) { return !!(f.closest && f.closest(SEL_FORA)); }
    var comId = null, comBotao = null, qualquer = null;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i]; if (deFora(f) || root.contains(f)) continue;
      var id = !!f.querySelector('[name="id"]'), botao = temBotao(f);
      if (id && botao) return f;
      if (id && !comId) comId = f; if (botao && !comBotao) comBotao = f; if (!qualquer) qualquer = f;
    }
    return comBotao || comId || qualquer;
  }
  function posicionar(root, form, antes) {
    // escape por tema: `inserir_antes` = seletor (dentro do formulário ou do bloco dele) antes do qual o widget entra
    if (antes) { var sec = form.closest && form.closest('.shopify-section');
      var a = form.querySelector(antes) || (form.parentNode && form.parentNode.querySelector(antes)) || (form.closest(antes)) || (sec && sec.querySelector(antes)); if (a && a.parentNode) { a.parentNode.insertBefore(root, a); root.hidden = false; return true; } }
    var alvo = form.querySelector('.product-form__buttons') || form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]') || form;
    if (alvo !== form && alvo.closest) alvo = alvo.closest('.product-form__buttons') || alvo;
    var subir = alvo.closest ? alvo.closest('product-form,.product-form,.product-form__buttons-wrapper') : null;
    if (subir && subir.parentNode && subir !== form.parentNode) alvo = subir;
    if (!alvo.parentNode) return false;
    alvo.parentNode.insertBefore(root, alvo);
    root.hidden = false;
    return true;
  }

  /* ------------------------------------------------------ variantes */
  function Variantes(produto) {
    this.p = produto; this.opcoes = produto.opcoes || []; this.v = produto.variantes || [];
  }
  Variantes.prototype.porOpcoes = function (escolha) {
    for (var i = 0; i < this.v.length; i++) { var ok = true; for (var j = 0; j < escolha.length; j++) if (this.v[i].opcoes[j] !== escolha[j]) { ok = false; break; } if (ok) return this.v[i]; }
    return null;
  };
  Variantes.prototype.valoresDisponiveis = function (indice, prefixo) {
    // valores da opção `indice` que existem (e estão disponíveis) dado o prefixo já escolhido
    var vistos = {}, lista = [];
    for (var i = 0; i < this.v.length; i++) {
      var ok = true; for (var j = 0; j < indice; j++) if (this.v[i].opcoes[j] !== prefixo[j]) { ok = false; break; }
      if (!ok) continue;
      var val = this.v[i].opcoes[indice];
      if (!(val in vistos)) { vistos[val] = false; lista.push(val); }
      if (this.v[i].disponivel) vistos[val] = true;
    }
    return lista.map(function (x) { return { valor: x, disponivel: vistos[x] }; });
  };
  Variantes.prototype.porId = function (id) { for (var i = 0; i < this.v.length; i++) if (String(this.v[i].id) === String(id)) return this.v[i]; return null; };

  /* ------------------------------------------------------ widget */
  function Widget(root) {
    var no = root.querySelector('[data-ewc-bundle-config]');
    var d = JSON.parse(no.textContent);
    this.root = root; this.cfg = d.cfg || {}; this.produto = d.produto; this.fmt = d.moneyFormat; this.rotas = d.rotas || {};
    this.raiz = ((window.Shopify && Shopify.routes && Shopify.routes.root) || this.rotas.raiz || '/').replace(/\/?$/, '/');
    this.vars = new Variantes(this.produto);
    this.barras = this.cfg.barras || [];
    this.selecionada = Math.max(1, Math.min(this.barras.length, parseInt(this.cfg.preselecionada || 1, 10))) - 1;
    this.unidades = [];   // [barraIndex][unidade] = escolha (array de valores de opção)
    this.extras = {};     // dados de produto dos upsells/brindes por handle
    this.ocupado = false;
    this.kaching = this.cfg.layout === 'kaching';   // marcação e medidas do Kaching Bundles (modo opcional)
    this.upVar = {};      // variante escolhida em cada linha de upsell: chave "barra:indice"
    this.form = achar(root, this.cfg.seletor_formulario);
    if (!this.form) throw new Error('formulário de compra não encontrado');
    if (this.kaching) root.classList.add('ewc-bundle--kaching');
    this.aplicarEstilo(); this.montar();
    if (!posicionar(root, this.form, this.cfg.inserir_antes)) throw new Error('não achei onde encaixar o widget');
    if (this.cfg.esconder_seletor_do_tema !== false && this.cfg.variantes_diferentes !== false && this.vars.v.length > 1) this.esconderPicker();
    // escape por tema: elementos que o app original escondia (ex.: seletor de quantidade)
    (this.cfg.esconder || []).forEach(function (sel) { document.querySelectorAll(sel).forEach(function (n) { if (!n.closest('.ewc-bundle')) n.classList.add('ewc-esconde-seletor'); }); });
    this.ligar(); this.render(); this.carregarExtras();
  }
  Widget.prototype.aplicarEstilo = function () {
    var e = this.cfg.estilo || {}, r = this.root.style;
    if (e.cor_destaque) r.setProperty('--eb-acento', e.cor_destaque);
    if (e.cor_selo) r.setProperty('--eb-selo', e.cor_selo);
    if (e.fundo_barra) r.setProperty('--eb-fundo', e.fundo_barra);
    if (e.fundo_selecionada) r.setProperty('--eb-fundo-sel', e.fundo_selecionada);
    if (e.anel) r.setProperty('--eb-anel', e.anel);
    if (e.raio != null) r.setProperty('--eb-raio', e.raio + 'px');
    if (e.fonte) r.setProperty('--eb-fonte', e.fonte);
    // cores do modo kaching (colors.* do deal)
    [['cor_titulo', '--eb-titulo'], ['cor_preco', '--eb-preco'], ['cor_cheio', '--eb-cheio'], ['cor_sub', '--eb-suave'],
     ['cor_titulo_bloco', '--eb-titulo-bloco'], ['fundo_upsell', '--eb-fundo-upsell'], ['cor_texto_selo', '--eb-texto-selo'], ['cor_texto', '--eb-texto']]
      .forEach(function (p) { if (e[p[0]]) r.setProperty(p[1], e[p[0]]); });
    if (e.css) { var st = el('style'); st.textContent = e.css; this.root.appendChild(st); }
  };
  Widget.prototype.esconderPicker = function () {
    var f = this.form, secao = f.closest('.shopify-section,section,[id^="shopify-section"]') || document;
    secao.querySelectorAll(SEL_PICKER).forEach(function (n) { if (!n.closest('.ewc-bundle')) n.classList.add('ewc-esconde-seletor'); });
  };
  Widget.prototype.variantePadrao = function () {
    var id = this.form.querySelector('[name="id"]'); var v = id && this.vars.porId(id.value);
    if (!v) v = this.vars.v.filter(function (x) { return x.disponivel; })[0] || this.vars.v[0];
    return v;
  };
  /* barra com abatimento por unidade: soma o preço real de cada unidade (variantes de preços
     diferentes) e tira o abatimento de cada uma — é a conta que o Kaching e o checkout fazem */
  Widget.prototype.somaBarra = function (i) {
    var b = this.barras[i], pad = this.variantePadrao(), preco = 0, cheio = 0, cmpTotal = 0;
    for (var u = 0; u < b.q; u++) {
      var esc = (this.unidades[i] || [])[u], v = (esc && this.vars.porOpcoes(esc)) || pad;
      preco += v.preco; cmpTotal += v.compare > v.preco ? v.compare : v.preco;
    }
    return { total: preco - Math.round((b.off_cada || 0) * 100) * b.q, bruto: preco, compare: cmpTotal };
  };
  /* barra sem desconto no checkout cobra o preço real de cada variante: soma real, não o total fixo */
  Widget.prototype.somaReal = function (b) { return b.off_cada != null || !b.desconto_titulo || (b.total == null && b.por_unidade == null); };
  Widget.prototype.precoUnitario = function () { var v = this.variantePadrao(); return v ? v.preco : 0; };
  Widget.prototype.compareUnitario = function () { var v = this.variantePadrao(); return v && v.compare > v.preco ? v.compare : 0; };

  Widget.prototype.montar = function () {
    if (this.kaching) return this.montarK();
    var self = this, cfg = this.cfg;
    this.root.querySelectorAll(':scope > :not(script):not(style)').forEach(function (n) { n.remove(); });
    if (cfg.titulo_bloco) this.root.appendChild(el('div', 'ewc-bundle__titulo', cfg.titulo_bloco));
    this.nosBarras = [];
    this.barras.forEach(function (b, i) {
      var lab = el('label', 'ewc-bundle__barra'); lab.setAttribute('data-ewc-bar', i + 1);
      var radio = el('input'); radio.type = 'radio'; radio.name = 'ewc-bundle-bar'; radio.value = String(i);
      lab.appendChild(radio);
      if (b.selo) lab.appendChild(el('span', 'ewc-bundle__selo', b.selo));
      var cab = el('div', 'ewc-bundle__cabeca');
      cab.appendChild(el('span', 'ewc-bundle__bolinha'));
      var tx = el('div', 'ewc-bundle__textos');
      var nome = el('div', 'ewc-bundle__nome'); nome.textContent = b.titulo || (b.q + ' un');
      if (b.etiqueta) nome.appendChild(el('span', 'ewc-bundle__etiqueta', b.etiqueta));
      tx.appendChild(nome);
      if (b.subtitulo) { var sub = el('div', 'ewc-bundle__sub'); sub.innerHTML = b.subtitulo; tx.appendChild(sub); }
      cab.appendChild(tx);
      var pr = el('div', 'ewc-bundle__precos'); pr.appendChild(el('span', 'ewc-bundle__preco')); pr.appendChild(el('span', 'ewc-bundle__cheio'));
      cab.appendChild(pr); lab.appendChild(cab);
      var un = el('div', 'ewc-bundle__unidades'); lab.appendChild(un);
      var ex = el('div', 'ewc-bundle__extras'); lab.appendChild(ex);
      self.root.appendChild(lab);
      self.nosBarras.push({ lab: lab, radio: radio, preco: pr.firstChild, cheio: pr.lastChild, unidades: un, extras: ex });
      self.unidades[i] = [];
    });
    this.propriedade = el('input'); this.propriedade.type = 'hidden'; this.propriedade.name = 'properties[_ewc_bundle]'; this.propriedade.setAttribute('data-ewc-injected', '1');
    this.form.appendChild(this.propriedade);
  };

  Widget.prototype.render = function () {
    if (this.kaching) return this.renderK();
    var self = this, cfg = this.cfg, p = this.precoUnitario(), cmp = this.compareUnitario();
    var usarCompare = (cfg.mostrar || {}).usar_compare_at !== false && cmp > 0;
    this.barras.forEach(function (b, i) {
      var n = self.nosBarras[i], sel = i === self.selecionada;
      n.lab.classList.toggle('is-selected', sel); n.radio.checked = sel;
      var total = Math.round((b.total != null ? b.total : (p * b.q) / 100) * 100);
      var cada = Math.round((b.por_unidade != null ? b.por_unidade : total / b.q / 100) * 100);
      var cheioTotal = (usarCompare ? cmp : p) * b.q;
      if (self.somaReal(b)) { var sb = self.somaBarra(i); total = sb.total; cada = Math.round(total / b.q); cheioTotal = usarCompare ? sb.compare : sb.bruto; }
      if ((cfg.mostrar || {}).por_unidade) {
        n.preco.textContent = enxuto(dinheiro(cada, self.fmt)) + ' each';
        var cheioCada = usarCompare ? cmp : p;
        n.cheio.textContent = cheioCada > cada ? enxuto(dinheiro(cheioCada, self.fmt)) : '';
      } else {
        n.preco.textContent = enxuto(dinheiro(total, self.fmt));
        n.cheio.textContent = cheioTotal > total ? enxuto(dinheiro(cheioTotal, self.fmt)) : '';
      }
      if (sel) { self.renderUnidades(i); self.renderExtras(i); }
    });
    this.atualizarForm();
  };

  Widget.prototype.renderUnidades = function (i) {
    var self = this, b = this.barras[i], n = this.nosBarras[i], cont = n.unidades;
    cont.innerHTML = '';
    if (this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) return;
    var padrao = this.variantePadrao();
    for (var u = 0; u < b.q; u++) {
      if (!this.unidades[i][u]) this.unidades[i][u] = padrao.opcoes.slice();
      var linha = el('div', 'ewc-bundle__unidade'); linha.appendChild(el('span', 'ewc-bundle__unidade-n', '#' + (u + 1)));
      this.vars.opcoes.forEach(function (nomeOpcao, k) {
        var escolha = self.unidades[i][u];
        var valores = self.vars.valoresDisponiveis(k, escolha);
        var swatch = self.cfg.swatches && self.cfg.swatches.opcao && self.cfg.swatches.opcao.toLowerCase() === String(nomeOpcao).toLowerCase() && self.cfg.swatches.cores;
        if (swatch) {
          var grupo = el('div', 'ewc-bundle__swatches'); grupo.setAttribute('role', 'radiogroup'); grupo.setAttribute('aria-label', nomeOpcao);
          valores.forEach(function (x) {
            var s = el('span', 'ewc-bundle__swatch'); s.title = x.valor; s.style.background = self.cfg.swatches.cores[x.valor] || '#ccc';
            s.classList.toggle('is-on', escolha[k] === x.valor); s.classList.toggle('is-off', !x.disponivel);
            s.setAttribute('data-ewc-opt', k); s.setAttribute('data-ewc-val', x.valor); s.setAttribute('data-ewc-un', u);
            grupo.appendChild(s);
          });
          linha.appendChild(grupo);
        } else {
          var s = el('select'); s.setAttribute('data-ewc-opt', k); s.setAttribute('data-ewc-un', u); s.setAttribute('aria-label', nomeOpcao);
          valores.forEach(function (x) { var o = el('option', null, x.valor + (x.disponivel ? '' : ' (Sold out)')); o.value = x.valor; o.disabled = !x.disponivel; s.appendChild(o); });
          s.value = escolha[k];
          linha.appendChild(s);
        }
      });
      cont.appendChild(linha);
    }
  };

  Widget.prototype.renderExtras = function (i) {
    var self = this, n = this.nosBarras[i], cont = n.extras; cont.innerHTML = '';
    var ups = (this.cfg.upsells || []).filter(function (u) { return !u.por_barra || !u.por_barra.length || u.por_barra.indexOf(i + 1) !== -1; });
    ups.forEach(function (u) {
      var linha = el('label', 'ewc-bundle__extra'); var cb = el('input'); cb.type = 'checkbox'; cb.setAttribute('data-ewc-upsell', u.handle);
      cb.checked = !!u.pre_marcado || (self.marcados && self.marcados[u.handle] === true);
      linha.appendChild(cb);
      var d = self.extras[u.handle];
      if (d && d.imagem) { var im = el('img'); im.src = d.imagem; im.alt = ''; linha.appendChild(im); }
      var txt = el('span', null, d ? d.titulo : u.handle);
      if (u.gratis) { txt.appendChild(document.createTextNode(' ')); txt.appendChild(el('span', 'ewc-bundle__extra-gratis', self.cfg.textos && self.cfg.textos.gratis || 'FREE')); if (d && d.compare) txt.appendChild(el('span', 'ewc-bundle__cheio', enxuto(dinheiro(d.compare, self.fmt)))); }
      else if (d) txt.appendChild(document.createTextNode(' ' + enxuto(dinheiro(d.preco, self.fmt))));
      linha.appendChild(txt); cont.appendChild(linha);
    });
    (this.cfg.brindes || []).forEach(function (g) {
      var livre = (i + 1) >= (g.a_partir_da_barra || 1);
      var linha = el('div', 'ewc-bundle__extra' + (livre ? '' : ' is-locked')); linha.setAttribute('data-ewc-gift', g.handle);
      var d = self.extras[g.handle];
      if (d && d.imagem) { var im = el('img'); im.src = d.imagem; im.alt = ''; linha.appendChild(im); }
      var txt = el('span', null, (d ? d.titulo : g.handle) + ' ');
      txt.appendChild(el('span', 'ewc-bundle__extra-gratis', livre ? (g.rotulo || 'FREE') : (self.cfg.textos && self.cfg.textos.travado || 'Locked')));
      if (d && d.compare) txt.appendChild(el('span', 'ewc-bundle__cheio', enxuto(dinheiro(d.compare, self.fmt))));
      linha.appendChild(txt); cont.appendChild(linha);
    });
  };

  /* ------------------------------------------------------ modo kaching
     Mesma marcação/medidas do Kaching Bundles: título com filetes, faixa com rádio,
     título/subtítulo à esquerda e preço + riscado à direita, fita de selo, seletores
     por unidade (miniatura + pílula com bolinha de cor), linhas de upsell/brinde em faixa
     própria visíveis em todas as barras (checkbox e seletor só na selecionada). */
  Widget.prototype.montarK = function () {
    var self = this, cfg = this.cfg;
    this.root.querySelectorAll(':scope > :not(script):not(style)').forEach(function (n) { n.remove(); });
    if (cfg.titulo_bloco) { var t = el('div', 'ewc-k__titulo'); t.appendChild(el('span', null, cfg.titulo_bloco)); this.root.appendChild(t); }
    this.nosBarras = [];
    this.barras.forEach(function (b, i) {
      var barra = el('div', 'ewc-k__barra');
      var lab = el('label', 'ewc-k__container'); lab.setAttribute('data-ewc-bar', i + 1);
      var radio = el('input'); radio.type = 'radio'; radio.name = 'ewc-bundle-bar'; radio.value = String(i); radio.className = 'ewc-k__input';
      lab.appendChild(radio);
      if (b.selo) { var fita = el('div', 'ewc-k__selo'); fita.appendChild(el('div', 'ewc-k__selo-texto', b.selo)); lab.appendChild(fita); }
      var wrap = el('div', 'ewc-k__wrapper');
      var main = el('div', 'ewc-k__main');
      // foto da barra (o "mediaImage" do Kaching) no lugar do rádio, quando a referência tem
      if (b.imagem) { var bim = el('img', 'ewc-k__img'); bim.src = b.imagem; bim.alt = ''; bim.loading = 'lazy'; main.appendChild(bim); }
      else main.appendChild(el('div', 'ewc-k__radio'));
      var cont = el('div', 'ewc-k__conteudo'), esq = el('div', 'ewc-k__esq');
      var l1 = el('div', 'ewc-k__linha1'); l1.appendChild(el('span', 'ewc-k__nome', b.titulo || (b.q + ''))); if (b.etiqueta && cfg.mostrar_etiqueta === true) l1.appendChild(el('span', 'ewc-k__etiqueta', b.etiqueta)); esq.appendChild(l1);
      if (b.subtitulo) { var l2 = el('div', 'ewc-k__linha2'); var sub = el('div', 'ewc-k__sub'); sub.innerHTML = b.subtitulo; l2.appendChild(sub); esq.appendChild(l2); }
      var pr = el('div', 'ewc-k__precos'); var pv = el('div', 'ewc-k__preco'), pc = el('div', 'ewc-k__cheio'); pr.appendChild(pv); pr.appendChild(pc);
      cont.appendChild(esq); cont.appendChild(pr); main.appendChild(cont); wrap.appendChild(main);
      var un = el('div', 'ewc-k__variantes'); wrap.appendChild(un);
      lab.appendChild(wrap);
      var ex = el('div', 'ewc-k__extras'); lab.appendChild(ex);
      barra.appendChild(lab); self.root.appendChild(barra);
      self.nosBarras.push({ lab: lab, barra: barra, radio: radio, preco: pv, cheio: pc, unidades: un, extras: ex });
      self.unidades[i] = [];
    });
    this.propriedade = el('input'); this.propriedade.type = 'hidden'; this.propriedade.name = 'properties[_ewc_bundle]'; this.propriedade.setAttribute('data-ewc-injected', '1');
    this.form.appendChild(this.propriedade);
  };

  Widget.prototype.renderK = function () {
    var self = this, cfg = this.cfg, p = this.precoUnitario(), cmp = this.compareUnitario();
    var usarCompare = (cfg.mostrar || {}).usar_compare_at !== false && cmp > 0;
    this.barras.forEach(function (b, i) {
      var n = self.nosBarras[i], sel = i === self.selecionada;
      n.lab.classList.toggle('is-selected', sel); n.barra.classList.toggle('is-selected', sel); n.radio.checked = sel;
      var total = Math.round((b.total != null ? b.total : (p * b.q) / 100) * 100);
      var cheioTotal = (usarCompare ? cmp : p) * b.q;
      if (self.somaReal(b)) { var sb = self.somaBarra(i); total = sb.total; cheioTotal = usarCompare ? sb.compare : sb.bruto; }
      var subK = b.subtitulo && b.subtitulo.indexOf('saved_total') >= 0 && n.lab.querySelector('.ewc-k__sub');
      if (subK) subK.innerHTML = b.subtitulo.replace(/\{\{\s*saved_total\s*\}\}/g, cheioTotal > total ? dinheiro(cheioTotal - total, self.fmt) : '');
      if ((cfg.mostrar || {}).por_unidade && (b.q > 1 || (cfg.mostrar || {}).por_unidade_todas)) {
        var cada = Math.round(total / b.q), cheioUn = usarCompare ? cmp : p;
        n.preco.textContent = dinheiro(cada, self.fmt);
        if (cfg.textos && cfg.textos.por_unidade) n.preco.appendChild(el('span', 'ewc-k__por-un', cfg.textos.por_unidade));
        n.cheio.textContent = cheioUn > cada ? dinheiro(cheioUn, self.fmt) : '';
      } else {
        n.preco.textContent = dinheiro(total, self.fmt);
        n.cheio.textContent = cheioTotal > total ? dinheiro(cheioTotal, self.fmt) : '';
      }
      if (sel) self.renderUnidadesK(i); else n.unidades.innerHTML = '';
      self.renderExtrasK(i, sel);
    });
    this.atualizarForm();
  };

  Widget.prototype.pilula = function (valores, atual, attrs, nomeOpcao) {
    // pílula branca com bolinha de cor (quando a opção é de cor) + <select> nativo transparente por cima
    var cores = this.cfg.swatches && this.cfg.swatches.cores || {};
    var ehCor = this.cfg.swatches && this.cfg.swatches.opcao && String(nomeOpcao).toLowerCase() === this.cfg.swatches.opcao.toLowerCase();
    var box = el('span', 'ewc-k__pilula');
    if (ehCor) { var bol = el('span', 'ewc-k__bolinha'); bol.style.background = cores[atual] || '#fff'; box.appendChild(bol); }
    box.appendChild(el('span', 'ewc-k__pilula-valor', atual));
    box.appendChild(el('span', 'ewc-k__seta'));
    var s = el('select'); Object.keys(attrs).forEach(function (k) { s.setAttribute(k, attrs[k]); }); s.setAttribute('aria-label', nomeOpcao);
    valores.forEach(function (x) { var o = el('option', null, x.valor + (x.disponivel ? '' : ' (Épuisé)')); o.value = x.valor; o.disabled = !x.disponivel; s.appendChild(o); });
    s.value = atual; box.appendChild(s);
    return box;
  };

  Widget.prototype.renderUnidadesK = function (i) {
    var self = this, b = this.barras[i], cont = this.nosBarras[i].unidades;
    cont.innerHTML = '';
    if (this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) return;
    var padrao = this.variantePadrao();
    cont.appendChild(el('div', 'ewc-k__rotulos', this.vars.opcoes.join(', ')));
    var linha = el('div', 'ewc-k__seletores');
    for (var u = 0; u < b.q; u++) {
      if (!this.unidades[i][u]) this.unidades[i][u] = padrao.opcoes.slice();
      var escolha = this.unidades[i][u], vAtual = this.vars.porOpcoes(escolha) || padrao;
      var item = el('div', 'ewc-k__unidade');
      if (this.cfg.numerar_unidades && b.q > 1) item.appendChild(el('span', 'ewc-k__num', '#' + (u + 1)));
      else if (this.cfg.miniatura !== false && (u === 0 || b.q > 1 && this.cfg.miniatura_por_unidade)) { var im = el('img', 'ewc-k__mini'); im.src = vAtual.imagem || ''; im.alt = ''; item.appendChild(im); }
      var sels = el('div', 'ewc-k__selects');
      this.vars.opcoes.forEach(function (nomeOpcao, k) {
        sels.appendChild(self.pilula(self.vars.valoresDisponiveis(k, escolha), escolha[k], { 'data-ewc-opt': k, 'data-ewc-un': u }, nomeOpcao));
      });
      item.appendChild(sels); linha.appendChild(item);
    }
    cont.appendChild(linha);
  };

  Widget.prototype.renderExtrasK = function (i, sel) {
    var self = this, cont = this.nosBarras[i].extras; cont.innerHTML = '';
    var ups = (this.cfg.upsells || []).map(function (u, idx) { return { u: u, idx: idx }; })
      .filter(function (x) { return !x.u.por_barra || !x.u.por_barra.length || x.u.por_barra.indexOf(i + 1) !== -1; });
    ups.forEach(function (x) {
      var u = x.u, d = self.extras[u.handle], chave = i + ':' + x.idx;
      var linha = el('div', 'ewc-k__upsell' + (sel ? ' is-selected' : ''));
      var mainU = el('div', 'ewc-k__upsell-main');
      if (sel) {
        var cb = el('input'); cb.type = 'checkbox'; cb.className = 'ewc-k__check'; cb.setAttribute('data-ewc-upsell', chave);
        var marcado = self.marcados && chave in self.marcados ? self.marcados[chave] : !!u.pre_marcado;
        cb.checked = marcado; var caixa = el('label', 'ewc-k__checkbox'); caixa.appendChild(cb); caixa.appendChild(el('span', 'ewc-k__checkmark')); mainU.appendChild(caixa);
      }
      var vEsc = d && (self.upVar[chave] && d.porId[self.upVar[chave]] || d.padrao);
      if (d) { var im = el('img', 'ewc-k__upsell-img'); im.src = (vEsc && vEsc.imagem) || d.imagem; im.alt = ''; mainU.appendChild(im); }
      var conteudo = el('div', 'ewc-k__upsell-conteudo');
      conteudo.appendChild(el('span', 'ewc-k__upsell-texto', u.texto || (d ? d.titulo : u.handle)));
      if (sel && d && d.opcoes.length && d.variantes.length > 1) {
        var vs = new Variantes({ opcoes: d.opcoes, variantes: d.variantes });
        d.opcoes.forEach(function (nomeOpcao, k) {
          conteudo.appendChild(self.pilula(vs.valoresDisponiveis(k, vEsc.opcoes), vEsc.opcoes[k], { 'data-ewc-up-opt': k, 'data-ewc-up-chave': chave, 'data-ewc-up-handle': u.handle }, nomeOpcao));
        });
      }
      mainU.appendChild(conteudo);
      var pr = el('div', 'ewc-k__upsell-precos');
      if (d) {
        var preco = u.gratis ? 0 : (vEsc ? vEsc.preco : d.preco), cheio = vEsc && vEsc.compare > preco ? vEsc.compare : d.compare;
        pr.appendChild(el('div', 'ewc-k__upsell-preco', u.gratis ? (self.cfg.textos && self.cfg.textos.gratis || 'Offert') : dinheiro(preco, self.fmt)));
        if (cheio) pr.appendChild(el('div', 'ewc-k__upsell-cheio', dinheiro(cheio, self.fmt)));
      }
      linha.appendChild(mainU); linha.appendChild(pr); cont.appendChild(linha);
    });
    var resumo = this.cfg.textos && this.cfg.textos.resumo_brindes;
    var daBarra = (this.cfg.brindes || []).filter(function (g) {
      if (g.por_barra && g.por_barra.length) return g.por_barra.indexOf(i + 1) !== -1;
      return (i + 1) >= (g.a_partir_da_barra || 1);
    });
    if (resumo && !sel && daBarra.length > 1) {
      var valor = daBarra.reduce(function (s, g) { var d = self.extras[g.handle]; return s + (d && d.compare ? d.compare * (g.quantidade || 1) : 0); }, 0);
      cont.appendChild(el('div', 'ewc-k__divisor'));
      var lr = el('div', 'ewc-k__brinde ewc-k__brinde--resumo');
      // miniaturas sobrepostas dos brindes, como o resumo do Kaching
      var ims = el('div', 'ewc-k__resumo-imgs');
      daBarra.forEach(function (g) { var d = self.extras[g.handle]; if (d && d.imagem) { var im = el('img', 'ewc-k__resumo-img'); im.src = d.imagem; im.alt = ''; ims.appendChild(im); } });
      if (ims.children.length) lr.appendChild(ims);
      lr.appendChild(el('span', 'ewc-k__brinde-texto', resumo.replace('{n}', daBarra.length).replace('{valor}', dinheiro(valor, self.fmt))));
      cont.appendChild(lr); return;
    }
    (this.cfg.brindes || []).forEach(function (g) {
      if (g.por_barra && g.por_barra.length && g.por_barra.indexOf(i + 1) === -1) return;
      if ((!g.por_barra || !g.por_barra.length) && (i + 1) < (g.a_partir_da_barra || 1)) return;
      var d = self.extras[g.handle], q = g.quantidade || 1;
      cont.appendChild(el('div', 'ewc-k__divisor'));
      var linha = el('div', 'ewc-k__brinde'); linha.setAttribute('data-ewc-gift', g.handle);
      if (d && d.imagem) { var im = el('img', 'ewc-k__upsell-img'); im.src = d.imagem; im.alt = ''; linha.appendChild(im); }
      linha.appendChild(el('span', 'ewc-k__brinde-texto', g.texto || ((d ? d.titulo : g.handle))));
      if (d && d.compare && g.mostrar_preco !== false) linha.appendChild(el('span', 'ewc-k__brinde-cheio', dinheiro(d.compare * q, self.fmt)));
      cont.appendChild(linha);
    });
  };

  Widget.prototype.carregarExtras = function () {
    var self = this, handles = [];
    (this.cfg.upsells || []).concat(this.cfg.brindes || []).forEach(function (x) { if (x.handle && handles.indexOf(x.handle) === -1) handles.push(x.handle); });
    handles.forEach(function (h) {
      fetch(self.raiz + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        var mini = function (src) { return (src || '').replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2'); };
        var variantes = (p.variants || []).map(function (x) {
          return { id: x.id, opcoes: x.options, preco: x.price, compare: x.compare_at_price || 0, disponivel: x.available,
                   imagem: x.featured_image ? mini(x.featured_image.src) : mini(p.featured_image) };
        });
        var porId = {}; variantes.forEach(function (x) { porId[x.id] = x; });
        var semOpcoes = (p.options || []).length === 1 && p.variants.length === 1 && /default/i.test(p.variants[0].title);
        self.extras[h] = { titulo: p.title, preco: v ? v.price : 0, compare: v && v.compare_at_price > v.price ? v.compare_at_price : (v && v.price === 0 && v.compare_at_price ? v.compare_at_price : 0),
                           variante: v ? v.id : null, imagem: self.kaching ? mini(p.featured_image) : (p.featured_image || '').replace(/(\.[a-z]+)(\?.*)?$/i, '_64x64$1$2'),
                           opcoes: semOpcoes ? [] : (p.options || []).map(function (o) { return o.name || o; }), variantes: variantes, porId: porId, padrao: v ? porId[v.id] : null };
        if (self.kaching) self.render(); else self.renderExtras(self.selecionada);
      }).catch(function () {});
    });
  };

  Widget.prototype.itens = function () {
    var b = this.barras[this.selecionada], contagem = {}, ordem = [];
    var padrao = this.variantePadrao();
    for (var u = 0; u < b.q; u++) {
      var v = (this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) ? padrao : (this.vars.porOpcoes(this.unidades[this.selecionada][u] || padrao.opcoes) || padrao);
      if (!(v.id in contagem)) { contagem[v.id] = 0; ordem.push(v.id); }
      contagem[v.id]++;
    }
    var itens = ordem.map(function (id) { return { id: parseInt(id, 10), quantity: contagem[id], properties: { _ewc_bundle: b.titulo || String(b.q) } }; });
    var self = this;
    this.root.querySelectorAll('[data-ewc-upsell]:checked').forEach(function (cb) {
      var chave = cb.getAttribute('data-ewc-upsell');
      if (self.kaching) {
        var u = (self.cfg.upsells || [])[parseInt(chave.split(':')[1], 10)], d = u && self.extras[u.handle];
        var vid = d && (self.upVar[chave] || (d.padrao && d.padrao.id));
        if (vid) itens.push({ id: parseInt(vid, 10), quantity: u.quantidade || 1, properties: { _ewc_upsell: '1' } });
        return;
      }
      var d2 = self.extras[chave];
      if (d2 && d2.variante) itens.push({ id: d2.variante, quantity: 1, properties: { _ewc_upsell: '1' } });
    });
    (this.cfg.brindes || []).forEach(function (g) {
      if (g.por_barra && g.por_barra.length) { if (g.por_barra.indexOf(self.selecionada + 1) === -1) return; }
      else if ((self.selecionada + 1) < (g.a_partir_da_barra || 1)) return;
      var vid = g.variante_id || (self.extras[g.handle] && self.extras[g.handle].variante);
      if (vid) itens.push({ id: parseInt(vid, 10), quantity: g.quantidade || 1, properties: { _ewc_gift: '1' } });
    });
    return itens;
  };

  Widget.prototype.atualizarForm = function () {
    var b = this.barras[this.selecionada]; this.propriedade.value = b.titulo || String(b.q);
    var distintos = {}; this.itens().forEach(function (i) { if (!i.properties._ewc_upsell && !i.properties._ewc_gift) distintos[i.id] = 1; });
    var multi = Object.keys(distintos).length > 1 || b.q > 1;
    this.form.classList.toggle('ewc-multi-variant', multi && this.cfg.esconder_expresso !== false);
    var sec = this.form.closest('.shopify-section,section'); if (sec) sec.classList.toggle('ewc-multi-variant', multi && this.cfg.esconder_expresso !== false);
    var bd = this.cfg.botao_dinamico;
    if (bd && bd.modelo) {
      var btn = this.form.querySelector('button[name="add"],[type="submit"]');
      var alvo = btn && (btn.querySelector('span') || btn);
      if (alvo) {
        if (!btn.hasAttribute('data-ewc-texto-original')) btn.setAttribute('data-ewc-texto-original', alvo.textContent);
        var sb = this.somaReal(b) ? this.somaBarra(this.selecionada) : null;
        var total = sb ? sb.total : Math.round(b.total * 100);
        var cheio = sb ? (this.compareUnitario() ? sb.compare : sb.bruto) : (this.compareUnitario() || this.precoUnitario()) * b.q;
        var economia = Math.max(0, cheio - total);
        var novo = economia > 0 ? bd.modelo.replace('{{economia}}', enxuto(dinheiro(economia, this.fmt))) : btn.getAttribute('data-ewc-texto-original');
        if (alvo.textContent !== novo) alvo.textContent = novo;
      }
    }
  };

  Widget.prototype.ligar = function () {
    var self = this;
    this.root.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t.name === 'ewc-bundle-bar') { self.selecionada = parseInt(t.value, 10); self.render(); return; }
      if (t.tagName === 'SELECT' && t.hasAttribute('data-ewc-opt')) {
        var k = parseInt(t.getAttribute('data-ewc-opt'), 10), u = parseInt(t.getAttribute('data-ewc-un'), 10);
        var esc = self.unidades[self.selecionada][u]; esc[k] = t.value;
        for (var j = k + 1; j < self.vars.opcoes.length; j++) { var vals = self.vars.valoresDisponiveis(j, esc); if (!vals.some(function (x) { return x.valor === esc[j]; })) esc[j] = (vals.filter(function (x) { return x.disponivel; })[0] || vals[0] || {}).valor; }
        self.render(); return;
      }
      if (t.tagName === 'SELECT' && t.hasAttribute('data-ewc-up-opt')) {
        var chave = t.getAttribute('data-ewc-up-chave'), d = self.extras[t.getAttribute('data-ewc-up-handle')];
        var atual = (self.upVar[chave] && d.porId[self.upVar[chave]] || d.padrao).opcoes.slice();
        atual[parseInt(t.getAttribute('data-ewc-up-opt'), 10)] = t.value;
        var vs = new Variantes({ opcoes: d.opcoes, variantes: d.variantes }), nv = vs.porOpcoes(atual);
        if (nv) self.upVar[chave] = nv.id;
        self.renderExtrasK(self.selecionada, true); self.atualizarForm(); return;
      }
      if (t.hasAttribute('data-ewc-upsell')) { self.marcados = self.marcados || {}; self.marcados[t.getAttribute('data-ewc-upsell')] = t.checked; self.atualizarForm(); }
    });
    this.root.addEventListener('click', function (ev) {
      var s = ev.target.closest && ev.target.closest('.ewc-bundle__swatch'); if (!s) return;
      ev.preventDefault();
      var k = parseInt(s.getAttribute('data-ewc-opt'), 10), u = parseInt(s.getAttribute('data-ewc-un'), 10);
      self.unidades[self.selecionada][u][k] = s.getAttribute('data-ewc-val');
      self.render();
    });
    this.form.addEventListener('submit', function (ev) {
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation(); self.comprar();
    }, true);
    this.form.setAttribute('data-ewc-bundle-form', '1');
    var self2 = this; window.addEventListener('pageshow', function () { self2.ocupado = false; var btn = self2.form.querySelector('button[name="add"],[type="submit"]'); if (btn) btn.disabled = false; });
  };

  Widget.prototype.comprar = function () {
    var self = this; if (this.ocupado) return; this.ocupado = true;
    var btn = this.form.querySelector('button[name="add"],[type="submit"]'); if (btn) btn.disabled = true;
    var itens = this.itens();
    fetch(this.raiz + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itens }) })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function (json) {
        document.dispatchEvent(new CustomEvent('ewc:cart:added', { bubbles: true, detail: { items: json.items || [json] } }));
        var depois = self.cfg.depois_de_adicionar || 'gaveta';
        if (depois === 'carrinho' || (depois === 'gaveta' && !window.EwcCart)) {
          // temas escutam em document OU em document.documentElement (Impact): avisa nos dois
          ['cart:refresh', 'cart:build', 'cart-drawer:open', 'ajaxProduct:added'].forEach(function (n) {
            document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent(n, { bubbles: true }));
          });
          var gaveta = document.querySelector('cart-drawer,#cart-drawer,.cart-drawer,[data-cart-drawer]');
          if (depois === 'carrinho' || !gaveta) { window.location.href = self.rotas.carrinho || (self.raiz + 'cart'); }
          else {
            // gaveta do tema (Dawn e derivados): busca a gaveta já com os itens e troca o elemento inteiro antes de abrir
            fetch(self.raiz + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
              var p = new DOMParser();
              if (s['cart-drawer']) { var novo = p.parseFromString(s['cart-drawer'], 'text/html').querySelector('cart-drawer'), atual = document.querySelector('cart-drawer'); if (novo && atual) { atual.replaceWith(novo); gaveta = novo; } }
              if (s['cart-icon-bubble']) { var bolha = document.getElementById('cart-icon-bubble'), nb = p.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section'); if (bolha && nb) bolha.innerHTML = nb.innerHTML; }
            }).catch(function () {}).then(function () {
              setTimeout(function () { var g = document.querySelector('cart-drawer') || gaveta; if (g.classList) g.classList.remove('is-empty'); if (typeof g.open === 'function') g.open(); else if (typeof g.show === 'function') g.show(); }, 120);
            });
          }
        }
      })
      .catch(function () { window.location.href = self.rotas.carrinho || (self.raiz + 'cart'); })
      .then(function () { self.ocupado = false; if (btn) btn.disabled = false; });
  };

  function iniciar() {
    document.querySelectorAll('[data-ewc-bundle]').forEach(function (root) {
      if (root._ewc) return;
      try { root._ewc = new Widget(root); window.EwcBundle = root._ewc; } catch (e) { root.hidden = true; if (window.console && console.debug) console.debug('[ewc-bundle] fora do ar:', e.message); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
